import React, { memo } from 'react';

import { DiplomaCard } from './DiplomaCard';

import { DBoxContainer } from './DiplomasBox.styled';

import { DiplomaBoxProps } from './DiplomaBox.types';

export const DiplomasBox = memo(
  ({
    diplomas,
    background,
    blockShadow,
    titleReverse,
    elementShadow,
    backgroundReverse,
    textColor,
  }: DiplomaBoxProps) => (
    <DBoxContainer>
      {diplomas.map((one) => (
        <DiplomaCard
          key={one.program}
          {...one}
          background={background}
          blockShadow={blockShadow}
          elementShadow={elementShadow}
          titleReverse={titleReverse}
          backgroundReverse={backgroundReverse}
          textColor={textColor}
        />
      ))}
    </DBoxContainer>
  ),
);
